import { AssetAssetAdministrationDistribution } from "./types";

export const getAssetAdministrationDistributionsToDisplay = (
  assetAdministrationDistributions: AssetAssetAdministrationDistribution[],
) => {
  return assetAdministrationDistributions
    .filter(
      assetAssetAdministrationDistribution =>
        assetAssetAdministrationDistribution.publish_statement ||
        !assetAssetAdministrationDistribution.payment_status,
    )
    .sort(
      (a, b) =>
        new Date(b.distribution.distribution_date).getTime() -
        new Date(a.distribution.distribution_date).getTime(),
    );
};
